export const POPOVER_INPUT_OFFSET_X = 15;
export const POPOVER_INPUT_SHARP_LEFT_OFFSET_X = 2;